
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-board",
      function () {
        return require("private-next-pages/job-board/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-board"])
      });
    }
  